function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "styleboard-header/retailer",
  transform: "translate(-1145.000000, -14.000000)",
  fill: "#323E48",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1151.49609,34.6816406 C1151.97461,34.6816406 1152.30664,34.4277344 1152.90234,33.9003906 L1156.27148,30.9023438 L1162.54102,30.9023438 C1165.45117,30.9023438 1167.01367,29.2910156 1167.01367,26.4296875 L1167.01367,18.9492188 C1167.01367,16.0878906 1165.45117,14.4765625 1162.54102,14.4765625 L1149.96289,14.4765625 C1147.05273,14.4765625 1145.49023,16.078125 1145.49023,18.9492188 L1145.49023,26.4296875 C1145.49023,29.3007812 1147.05273,30.9023438 1149.96289,30.9023438 L1150.43164,30.9023438 L1150.43164,33.4414062 C1150.43164,34.1933594 1150.8125,34.6816406 1151.49609,34.6816406 Z M1151.89648,32.8945312 L1151.89648,30.0625 C1151.89648,29.5351562 1151.69141,29.3300781 1151.16406,29.3300781 L1149.96289,29.3300781 C1147.99023,29.3300781 1147.0625,28.3242188 1147.0625,26.4199219 L1147.0625,18.9492188 C1147.0625,17.0449219 1147.99023,16.0488281 1149.96289,16.0488281 L1162.54102,16.0488281 C1164.50391,16.0488281 1165.44141,17.0449219 1165.44141,18.9492188 L1165.44141,26.4199219 C1165.44141,28.3242188 1164.50391,29.3300781 1162.54102,29.3300781 L1156.21289,29.3300781 C1155.66602,29.3300781 1155.39258,29.4082031 1155.02148,29.7890625 L1151.89648,32.8945312 Z M1156.31055,27.4746094 C1156.83789,27.4746094 1157.14062,27.1132812 1157.14062,26.5371094 L1157.14062,23.7050781 L1160.10938,23.7050781 C1160.65625,23.7050781 1161.03711,23.421875 1161.03711,22.8945312 C1161.03711,22.3574219 1160.67578,22.0644531 1160.10938,22.0644531 L1157.14062,22.0644531 L1157.14062,19.046875 C1157.14062,18.4707031 1156.83789,18.109375 1156.31055,18.109375 C1155.7832,18.109375 1155.5,18.4902344 1155.5,19.046875 L1155.5,22.0644531 L1152.54102,22.0644531 C1151.96484,22.0644531 1151.59375,22.3574219 1151.59375,22.8945312 C1151.59375,23.421875 1151.99414,23.7050781 1152.54102,23.7050781 L1155.5,23.7050781 L1155.5,26.5371094 C1155.5,27.09375 1155.7832,27.4746094 1156.31055,27.4746094 Z",
  id: "comment-section"
})));

function SvgIconComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "21px",
    viewBox: "0 0 23 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "comment section") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComments);
export default __webpack_public_path__ + "static/media/icon_comments.f49f5cf8.svg";
export { ForwardRef as ReactComponent };